import React, { FunctionComponent, useEffect } from 'react';
import { Presentation } from './presentation';

type Props = {
  isPc: boolean;
  isShow: boolean;
  mail: string;
  tel: string;
  twitter: string;
  instagram: string;
  penIconImg: string;
  personId: number;
  handleOpenModal: (target: string, title: string) => void;
  handleFetchSidebarDetails: () => void;
};

export const Component: FunctionComponent<Props> = ({
  isPc,
  isShow,
  mail,
  tel,
  twitter,
  instagram,
  penIconImg,
  personId,
  handleOpenModal,
  handleFetchSidebarDetails,
}) => {
  useEffect(() => {
    handleFetchSidebarDetails();
  }, []);

  const handleClick = (target: string, title: string) => {
    handleOpenModal(target, title);
  };

  return (
    <Presentation
      isPc={isPc}
      isShow={isShow}
      mail={mail}
      tel={tel}
      twitter={twitter}
      instagram={instagram}
      penIconImg={penIconImg}
      personId={personId}
      handleClick={handleClick}
    />
  );
};
